import type { SupWeb3Address } from "@/types";
import { createStore } from "zustand/vanilla";
import { persist } from "zustand/middleware";

export interface ClaimRewardsState {
  chainId: number | undefined;
  txData: SupWeb3Address | undefined;
  isFinished: boolean | undefined;
}

export interface ClaimRewardsActions {
  setChainId: (chainId: number) => void;
  setTxData: (txData: SupWeb3Address) => void;
  setFinished: () => void;
  reset: () => void;
}

export type ClaimRewardsStore = ClaimRewardsState & ClaimRewardsActions;

export const defaultInitState: ClaimRewardsState = {
  chainId: undefined,
  txData: undefined,
  isFinished: undefined,
};

export const createClaimRewardsStore = (initState: ClaimRewardsState = defaultInitState) => {
  return createStore<ClaimRewardsStore>()(
    persist(
      set => ({
        ...initState,
        setChainId: chainId => set(() => ({ chainId })),
        setTxData: txData => set(state => ({ ...state, txData })),
        setFinished: () => set(state => ({ ...state, isFinished: true })),
        reset: () => set(() => defaultInitState),
      }),
      { name: "zstnd-claim-reward" }
    )
  );
};
